<template>
  <div class="sc-tabs">
    <div class="header">
      <ul>
        <li v-for="spinningTab in spinningTabs" :key="spinningTab.id" :class="spinningTab.align" @click="shiftTabs(spinningTab.align)">
          <div @click="shiftTabs('left')" class="shift" v-if="spinningTab.tab.isSelected"><i class="sc-icon-arrow-left"/></div>
          <div class="sc-tab-header-slot-wrapper">
            <div class="sc-tab-gradient" :class="spinningTab.align" v-if="!spinningTab.tab.isSelected"></div>
            <vnodes :vnodes="spinningTab.tab.$slots.header"></vnodes>
          </div>
          <div @click="shiftTabs('right')" class="shift" v-if="spinningTab.tab.isSelected"><i class="sc-icon-arrow-right"/></div>
        </li>
      </ul>
    </div>
    <div class="subheader">
      <slot name="subheader"></slot>
    </div>
    <div class="content">
      <slot/>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import utilsMixin from '../../mixins/utils'

export default {
  name: 'ScTabs',

  mixins: [utilsMixin],

  components: {
    Vnodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes
    }
  },

  props: {
    selectedTab: null
  },

  data () {
    return {
      // tabs[0]: left (or right as well in case of only 2 tabs), tabs[1]: selected, optional tabs[2]: right
      // the remaining not visible by design.
      tabs: []
    }
  },
  created () {
    this.$nextTick(function () {
      let tabChildren = this.$children.filter(c => c.$options.name === 'ScTab')
      let selectedIndex = this.selectedTab !== null && this.selectedTab !== undefined ? tabChildren.findIndex(child => child.id === this.selectedTab) : tabChildren.findIndex(child => child.isSelected)
      // sort the children to ensure the tabs[1] will be the selected
      for (let i = 0; i < tabChildren.length; ++i) {
        if (this.tabs.length === 1) {
          this.tabs.push(tabChildren[selectedIndex])
          Vue.set(tabChildren[selectedIndex], 'isSelected', true)
        }
        if (i !== selectedIndex) {
          this.tabs.push(tabChildren[i])
          Vue.set(tabChildren[i], 'isSelected', false)
        }
      }
    })
  },
  methods: {
    shiftTabs (direction) {
      Vue.set(this.tabs[this.tabs.findIndex(tab => tab.isSelected)], 'isSelected', false)

      if (direction === 'right') {
        let firstElement = this.tabs.shift()
        this.tabs.push(firstElement)
      } else if (direction === 'left') {
        let lastElement = this.tabs.pop()
        this.tabs.unshift(lastElement)
      }

      Vue.set(this.tabs[1], 'isSelected', true)
      const url = this.tabs[1].$options.propsData.url
      if (url) {
        this.$router.push(url)
      }

      this.$emit('tabSelect', this.tabs[1])
      this.forceUpdateOnHeaders()
    },

    forceUpdateOnHeaders () {
      this.$nextTick(() => {
        this.tabs.forEach(t => {
          t.$slots.header && t.$slots.header[0] && t.$slots.header[0].context && t.$slots.header[0].context.$forceUpdate()
        })
      })
    }
  },
  computed: {
    spinningTabs () {
      let result = []
      let selectedIndex = this.tabs.findIndex(tab => tab.isSelected)

      if (selectedIndex < 0) {
        return result
      }

      let rightIndex = this.tabs.length === 2 ? 0 : 2

      result.push({ align: 'left', tab: this.tabs[0], id: this.generateId() })
      result.push({ align: 'selected', tab: this.tabs[1], id: this.generateId() })
      result.push({ align: 'right', tab: this.tabs[rightIndex], id: this.generateId() })
      return result
    }
  },

  watch: {
    selectedTab (newVal, oldVal) {
      if (newVal === null || newVal === oldVal) return
      while (this.tabs[1].id !== newVal) {
        let lastElement = this.tabs.pop()
        this.tabs.unshift(lastElement)
      }
      Vue.set(this.tabs[0], 'isSelected', false)
      Vue.set(this.tabs[1], 'isSelected', true)
      Vue.set(this.tabs[2], 'isSelected', false)
      this.$emit('tabSelect', this.tabs[1])
      this.forceUpdateOnHeaders()
    }
  }
}
</script>

<style scoped lang="scss">
.sc-tabs {
  display: flex;
  flex-direction: column;

  .header {
    font-family: $sc-tabs-font-family;
    font-size: $sc-tabs-font-size;
    font-weight: $sc-tabs-header-font-weight;
    letter-spacing: $sc-tabs-letter-spacing;

    .shift {
      cursor: pointer;
      color: $sc-tabs-header-arrow-color;
      font-size: 30px;
      z-index: 1000;
    }

    ul {
      padding: 0px;
      margin: unset;

      li {
        list-style-type: none;
        float: left;
        position: relative;
        text-align: center;
        width: 33.33%;

        &.selected {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
        }

        .sc-tab-gradient {
          width: 100%;
          height: 100%;
          position: absolute;
          cursor: pointer;

          &.left {
            background: linear-gradient(to left, rgba(255, 255, 255, 0) 0%, $sc-tabs-header-bg-color 85%);
          }

          &.right {
            background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, $sc-tabs-header-bg-color 85%);
          }
        }
      }
    }
  }
}
</style>
